import React from 'react'
import PropTypes from 'prop-types'
import * as S from './styled'

// Réplica de ToggleTabs del Storybook de Velora (hrbf_freezer/src/ui/components/ToggleTabs)
const ToggleTabs = ({ value, onChange, tabs }) => (
  <S.Container role="tablist">
    {tabs.map(tab => {
      const Icon = tab.icon
      const selected = value === tab.value
      return (
        <S.Tab
          key={String(tab.value)}
          type="button"
          role="tab"
          aria-selected={selected}
          selected={selected}
          onClick={() => !selected && onChange(tab.value)}
        >
          {Icon && <Icon />}
          {tab.label}
        </S.Tab>
      )
    })}
  </S.Container>
)

ToggleTabs.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  tabs: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.node,
    value: PropTypes.any,
    icon: PropTypes.elementType
  })).isRequired
}

export default ToggleTabs
